




































import Vue from 'vue'

import { store } from 'base/store'
import { UserAccess } from 'base/store/state.interface'

export default Vue.extend({
  props: {
    hide: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    auxNavTemplate(): (() => Promise<any>) | null {
      return this.componentFactory(this.$store.state.navigation.auxNavTemplate)
    },
    customTemplate(): (() => Promise<any>) | null {
      return this.componentFactory(this.$store.state.navigation.customTemplate)
    },
    // Links to legacy (non-vue) sites
    anchors(): any[] {
      if (!store.state.user || !store.state.user.access) return []

      const access: UserAccess = store.state.user.access
      const anchors: { id: number, title: string, href: string, icon: string }[] = []

      // Add link to first available element
      if (access.alarm) {
        anchors.push({ id: 1, title: 'Meldungen', href: '/meldungen/alarmierungen.html', icon: 'Bell' })
      } else if (access.news) {
        anchors.push({ id: 1, title: 'Meldungen', href: '/meldungen/mitteilungen.html', icon: 'Bell' })
      } else if (access.event) {
        anchors.push({ id: 1, title: 'Meldungen', href: '/meldungen/termine.html', icon: 'Bell' })
      } else if (access.report) {
        anchors.push({ id: 1, title: 'Meldungen', href: '/meldungen/report.html', icon: 'Bell' })
      }

      if (access.monitor) {
        anchors.push({ id: 2, title: 'Monitor', href: '/monitor/1.html', icon: 'Monitor' })
      }

      if (access.management) {
        anchors.push({ id: 2, title: 'Verwaltung', href: '/localmanagement/index.html', icon: 'Wrench' })
      }

      return anchors
    },
    links(): any[] {
      const menu: any = []

      if (store.state.cluster.settings.test_beta) {
        menu.push({
          title: 'Dashboards',
          name: 'dashboards',
          icon: 'ViewDashboard'
        })
        menu.push({
          title: 'Messenger',
          name: 'messenger',
          icon: 'Chat'
        })
        menu.push({
          title: 'Meldungen',
          name: 'messages',
          icon: 'Bell',
          onlyWhenMatched: true
        })
      }

      return menu
    },
    matchedRoutes(): string[] {
      const routes: string[] = []
      this.$route.matched.forEach(route => routes.push(route.name!))
      return routes
    }
  },
  methods: {
    componentFactory(templateName: string) {
      if (!templateName)  return null

      return () => import(`../../${templateName}.vue`)
    },
    displayLink(route: any) {
      if (!route.onlyWhenMatched) return true

      return this.matchedRoutes.indexOf(route.name) > -1
    }
  }
})
